// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#student-no-career-paths {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: #00375d;
  padding-bottom: 20px;
  padding-top: 20px;
}

div#student-no-career-paths .message-container {
  flex-wrap: wrap;
  align-self: center;
}

div#student-no-career-paths .message-title {
  color: white;
  font-weight: bold;
  font-size: 22px;
  align-self: center;
}

div#student-no-career-paths .message-link {
  color: white;
  font-size: 14px;
  align-self: center;
}

div#student-no-career-paths > img {
  height: 7.5em;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentNoCareerPaths.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["div#student-no-career-paths {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  align-content: center;\n  justify-content: center;\n  background-color: #00375d;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n\ndiv#student-no-career-paths .message-container {\n  flex-wrap: wrap;\n  align-self: center;\n}\n\ndiv#student-no-career-paths .message-title {\n  color: white;\n  font-weight: bold;\n  font-size: 22px;\n  align-self: center;\n}\n\ndiv#student-no-career-paths .message-link {\n  color: white;\n  font-size: 14px;\n  align-self: center;\n}\n\ndiv#student-no-career-paths > img {\n  height: 7.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
